<template>
  <v-form ref="form" v-model="valid">
    <v-card flat>
      <div class="close-btn">
        <v-btn @click="closeMe" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-card flat>
          <v-card-text>
            <v-layout align-center class="green--text">
              <h2>
                {{
                  workplaceData
                    ? $t('Workplaces.FormEdit')
                    : $t('Workplaces.FormNew')
                }}
              </h2>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-text-field
          class="mr-4 mb-2 thin-border"
          v-model="formData.local"
          :rules="mandatoryRule"
          label="Local"
          type="text"
          required
        />

        <v-text-field
          class="mr-4 mb-2 thin-border"
          v-model="formData.area"
          label="Unidade / Área"
          type="text"
        />
        <v-card-actions>
          <v-btn
            :disabled="!valid"
            :loading="loading"
            color="success"
            @click="submit"
            >{{ $t('common.Submit') }}</v-btn
          >
          <v-btn flat color="gray" @click="closeMe">{{
            $t('common.Cancel')
          }}</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    closeMe: {
      required: true,
      type: Function
    },
    workplaceData: {
      default: null
    }
  },
  data() {
    return {
      formData: null,
      loading: false,
      valid: false
    }
  },
  computed: {
    ...mapGetters(['user', 'workplaces']),
    mandatoryRule() {
      return [v => !!v || this.$t('common.RequiredField')]
    }
  },
  methods: {
    ...mapActions([
      'addWorkplace',
      'updateWorkplace',
      'showSuccessSnackbar',
      'showErrorSnackbar'
    ]),
    submit() {
      this.loading = true

      const addOrUpdate = this.workplaceData
        ? this.updateWorkplace
        : this.addWorkplace

      const entry = { ...this.formData, userId: this.$store.getters.user.id }

      addOrUpdate(entry)
        .then(() => {
          if (this.workplaceData) {
            this.showSuccessSnackbar(this.$t('Workplaces.WorkplaceUpdated'))
          } else {
            this.showSuccessSnackbar(this.$t('Workplaces.WorkplaceAdded'))
          }
        })
        .catch(err => {
          this.showErrorSnackbar(err.message || 'Something went wrong')
        })
        .finally(() => {
          this.loading = false
          this.closeMe()
        })
    }
  },
  created() {
    this.formData = this.workplaceData
      ? {
          ...this.workplaceData
        }
      : {}
  }
}
</script>

<style>
.theme--light.v-input--is-disabled input {
  color: black !important;
}
</style>
